module.exports = __webpack_public_path__ + "img/arrow-right-gray.86e27a92.svg";